import React from 'react';
import { Typography } from '@mui/material';

/**
 * Refund ID template
 */
export const RefundIdTemplate: React.FC<{ id?: string }> = ({ id }) => (
  <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.8rem' }}>
    {id || '-'}
  </Typography>
);

export default RefundIdTemplate;
